import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popover, Spin } from '@jjj/components';
import flags from 'country-flag-icons/react/3x2';
import { COUNTRIES } from '../../../helpers/countries';
import authActions from '../../../redux/auth/actions';
import { getUnreadTotalCount, getNotificationsUnreadCountByCountryId } from '../../../helpers/notifications';
import CountryButton, {
  Wrapper,
  Title,
  Countries,
  CountryImage,
  CountryImageWrapper,
  SpinWrapper,
} from './topbarCountry.style';
import { NotificationBadge } from '../notificationBadge/notificationBadge';
import { t } from '../../../i18n';

class TopbarCountry extends Component {
  constructor(props) {
    super(props);
    this.handlePopoverVisibleChange = this.handlePopoverVisibleChange.bind(this);
  }

  state = { isPopoverVisible: false };

  handlePopoverVisibleChange() {
    const { isPopoverVisible } = this.state;
    this.setState({ isPopoverVisible: !isPopoverVisible });
  }

  getPopverContent = () => {
    const { auth, notificationsUnreadCount } = this.props;
    const { selectedCountry, countries } = auth;

    return (
      <Countries>
        {countries?.length > 0 &&
          countries.map(country => {
            const isCurrentCountry = country.name === selectedCountry.code;
            const [{ new_count }] = getNotificationsUnreadCountByCountryId(notificationsUnreadCount, country.id);
            const countryData = COUNTRIES[country.name];
            const alpha2Code = countryData?.alpha_2_code;
            const displayName = countryData?.name || country.name;

            return (
              <CountryButton key={country.id} disabled={isCurrentCountry} onClick={() => this.onCountryClick(country)}>
                <CountryImageWrapper>
                  {isCurrentCountry ? <i className="fas fa-check-circle" /> : <NotificationBadge count={new_count} />}
                  <CountryImage>{this.getFlagComponent(alpha2Code, displayName)}</CountryImage>
                </CountryImageWrapper>
                {displayName}
              </CountryButton>
            );
          })}
      </Countries>
    );
  };

  onCountryClick = country => {
    if (country && country.id) {
      this.props.updateSelectedCountry(country.id);
    }

    setTimeout(() => {
      this.setState({ isPopoverVisible: false });
    }, 200);
  };

  getFlagComponent = (countryCode, countryName) => {
    const FlagComponent = flags[countryCode];

    if (!FlagComponent) {
      return null;
    }

    return <FlagComponent title={countryName || ''} />;
  };

  render() {
    const { isPopoverVisible } = this.state;
    const { auth, notificationsUnreadCount } = this.props;
    const { selectedCountry, isChangeCountryLoading } = auth;
    const otherCountiesNotifications =
      notificationsUnreadCount && notificationsUnreadCount.filter(item => item.country_id !== selectedCountry.id);
    const totalUnreadCount = getUnreadTotalCount(otherCountiesNotifications);

    return (
      <Popover
        title={<Title>{t('dash.topbar.country_select_title')}</Title>}
        content={this.getPopverContent()}
        open={isPopoverVisible}
        trigger="click"
        onOpenChange={this.handlePopoverVisibleChange}
        placement="bottomRight"
        popupAlign={{ offset: [8, 5] }}
      >
        <Wrapper>
          {isChangeCountryLoading && (
            <SpinWrapper>
              <Spin />
            </SpinWrapper>
          )}
          {!isChangeCountryLoading && (
            <>
              {selectedCountry &&
                this.getFlagComponent(
                  COUNTRIES[selectedCountry.code]?.alpha_2_code,
                  COUNTRIES[selectedCountry.code]?.name || selectedCountry.code,
                )}
              <NotificationBadge count={totalUnreadCount} />
            </>
          )}
        </Wrapper>
      </Popover>
    );
  }
}

export default connect(
  state => ({
    ...state.App,
    auth: state.Auth,
  }),
  dispatch => ({
    updateSelectedCountry: /* istanbul ignore next */ data => dispatch(authActions.updateSelectedCountryRequest(data)),
  }),
)(TopbarCountry);
